import {
  Component,
  ComponentRef,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from '@angular/forms';
import {MatStepper} from '@angular/material/stepper';
import {Subject} from 'rxjs';
import {MatSelectModule} from '@angular/material/select';
import {NotFoundError} from '../common/not-found-error';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AlertService} from '../services/alert.service';
import {MatExpansionModule} from '@angular/material/expansion';
import {CommonModule} from '@angular/common';
import {MatCardModule} from '@angular/material/card';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {ApplicationsComponent} from '../components/applications/applications.component';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {EventSourceService} from "../services/event-source.service";
import {MatTooltipModule} from "@angular/material/tooltip";
import {ApplicationNotification} from "../core/modules/openapi";
import Keycloak from "keycloak-js";

export interface CreateApplicationDialogData {
  insurer: string,
  quotationID: string;
}

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass'],
  standalone: true,
  imports: [
    MatExpansionModule,
    MatCardModule,
    MatSelectModule,
    MatButtonModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatIconModule,
    ReactiveFormsModule,
    CommonModule,
    ApplicationsComponent,
    MatTooltipModule
  ]
})
export class HomeComponent implements OnInit, OnDestroy {
  @ViewChild('stepper', {static: false}) stepper: MatStepper;
  @ViewChild('container', {static: false, read: ViewContainerRef}) container: ViewContainerRef;
  @ViewChild('scrollFrame', {static: false}) scrollFrame: ElementRef;
  @ViewChild(ApplicationsComponent) appsComponent: ApplicationsComponent;

  scrollTop: number | undefined = undefined;
  components: ComponentRef<any>[] = [];
  homeForm: FormGroup;
  /** Subject that emits when the component has been destroyed. */
  protected _onDestroy = new Subject<void>();

  //flags
  showResult: boolean = false;
  step_error = false;
  mode: String = 'indeterminate';
  color: String = 'primary';
  value: Number = 100;
  enabled: boolean = false;
  private readonly keycloak = inject(Keycloak);

  constructor(private readonly alertService: AlertService,
              private readonly snackBar: MatSnackBar, private readonly eventSourceService: EventSourceService
  ) {
  }

  /**
   * Form initialization
   */
  ngOnInit() {
    this.connectToEventSource();
  }

  connectToEventSource() {
    this.eventSourceService.connectToServerSentEvents({
      withCredentials: true,
      headers: {'Authorization': 'Bearer ' + this.keycloak.token}
    }).subscribe({
      next: (msg) => {
        let notification: ApplicationNotification = JSON.parse(msg);
        let snackBarRef = this.snackBar.open(notification.title + " - " + notification.description, 'Recargar aplicaciones', {
          duration: 5000
        });
        this.appsComponent.reloadSearch(undefined);
        snackBarRef.onAction().subscribe(() => {
          this.appsComponent.reloadSearch(undefined);
          console.log("refresh");
        });
      },
      error: (error) => {
        setTimeout(() => this.connectToEventSource(), 5000);
      },
      complete: () => {
        console.log('complete');
      }
    });
  }

  ngOnDestroy() {
    this.eventSourceService.close();
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  validateAllFormFields(formGroup
                        :
                        FormGroup
  ) {
    (<any>Object).values(formGroup.controls).forEach((control: FormGroup<any>) => {
      control.markAsTouched();

      if (control.controls) {
        this.validateAllFormFields(control);
      }
    });
  }

  handleError(error
              :
              {
                originalError: {
                  status: number;
                  error: {
                    message: string;
                  };
                  message: string;
                };
              }
    ,
              sequence: number
  ) {
    this.step_error = true;
    this.showResult = true;
    this.mode = "determinate";
    this.components[sequence - 1].instance.panel.open();

    if (error instanceof NotFoundError) {
      this.alertService.warn('No elements found. Please check your filters');
    } else if (error.originalError.status === 401) {
      this.alertService.error('Authentication Error! Please check your credentials.');
    } else {
      this.alertService.error('An Error Occured');
      if (error.originalError.error) {
        this.alertService.error(error.originalError.error.message);
      } else {
        this.alertService.error(error.originalError.message);
      }
    }
    if (sequence != 0) {
      this.components[sequence - 1].instance.dynamicForm.enableSubmit();
    }
  }
}
